import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography, TextField, Stack, Card, Divider } from '@mui/material';
import * as dict from '../../dictionary'
import { ProfileContext } from '../../contexts/ProfileContext';

const SummaryDetailSection = ({ title, items }) => {
    return (
        <Card
            sx={{
                backgroundColor: '#ffffff', // พื้นหลังสีขาว
                color: '#000000', // ตัวอักษรสีดำ
                padding: 3,
                marginBottom: 3,
                border: '1px solid #ccc' // ขอบสีเทาอ่อน
            }}
        >
            <Typography
                variant="h6"
                component="h3"
                sx={{
                    textAlign: 'center',
                    marginBottom: 3,
                    color: '#000000', // ตัวอักษรสีดำ
                    fontWeight: 'medium'
                }}
            >
                {title}
            </Typography>

            <Stack spacing={2}>
                {items.map((item, index) => (
                    <Stack key={index} direction="row" alignItems="center" spacing={2}>
                        <Typography
                            variant="body2"
                            sx={{
                                minWidth: '90px',
                                color: '#000000', // ตัวอักษรสีดำ
                                textAlign: 'right'
                            }}
                        >
                            {item.label}
                        </Typography>
                        <Box
                            variant="outlined"
                            size="small"
                            sx={{
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                minWidth: '50px',
                                width: '100%',
                                '& .MuiInputBase-root': {
                                    backgroundColor: '#ffffff', // input สีขาว
                                    color: '#000000', // ตัวอักษรในช่อง input สีดำ
                                },
                                '& .MuiInputBase-input': {
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    color: '#000000'
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#ccc', // ขอบ input สีเทาอ่อน
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#888',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#555',
                                    },
                                    '&.Mui-disabled fieldset': {
                                        borderColor: '#ddd',
                                    }
                                }
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <label>{item.value.toLocaleString('th-TH', { minimumFractionDigits: 2 })}</label>
                                <label>บาท</label>
                            </div>
                        </Box>
                    </Stack>
                ))}
            </Stack>
        </Card>
    );
};

export const SummaryDetailPage = () => {
    const location = useLocation();
    const summary = location.state;
    const [profile, setProfile] = useState(null);
    const context = useContext(ProfileContext)

    useEffect(() => {
        if (context.state?.profile !== null) {
            setProfile(context.state?.profile?.customer[0])
        }
    }, [context])

    const summaryData = [
        {
            title: dict.Total_overdude_balance_TXT[profile?.language],
            items: [
                { label: dict.main_overdude_TXT[profile?.language], value: summary?.main_overdue_amount || 0 },
                { label: dict.extend_overdude_TXT[profile?.language], value: summary?.extend_overdue_amount || 0 },
                { label: dict.Summary_overdude_balance_TXT[profile?.language], value: (summary?.main_overdue_amount || 0) + (summary?.extend_overdue_amount || 0) }
            ]
        },
        {
            title:  dict.Total_all_balance_TXT[profile?.language],
            items: [
                { label: dict.main_overdude_TXT[profile?.language], value: summary?.main_remain_amount || 0 },
                { label:  dict.extend_overdude_TXT[profile?.language], value: summary?.extend_remain_amount || 0 },
                { label: dict.Summary_Total_all_balance_TXT[profile?.language], value: (summary?.main_remain_amount || 0) + (summary?.extend_remain_amount || 0) }
            ]
        }
    ];

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: '#ffffff', // เปลี่ยนพื้นหลังเป็นขาว
                padding: 3,
                color: '#000000' // ตัวอักษรเป็นสีดำ
            }}
        >
            <Box sx={{
                maxWidth: '600px',
                margin: '0 auto'
            }}>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        textAlign: 'center',
                        marginBottom: 4,
                        color: 'white',
                        fontWeight: 'bold'
                    }}
                >
                    Summary Detail
                </Typography>

                {summaryData.map((section, index) => (
                    <SummaryDetailSection
                        key={index}
                        title={section.title}
                        items={section.items}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default SummaryDetailPage;